import React from 'react';

import Flexbox from 'flexbox-react';

import { observer, Provider } from 'mobx-react';

import ToastStore from '../stores/ToastStore';
import AppStore from '../stores/AppStore';
import CurrentUserStore from '../stores/CurrentUserStore';

import { Card, Icon } from '@blueprintjs/core';

import Utilities from '../utils/Utilities';

import Cookies from 'js-cookie';

import '../components/VersionSwitch/versionSwitch.css';

@observer
export default class VersionSwitchView extends React.Component {

  render() {
    const stores = {
      AppStore,
      CurrentUserStore,
      ToastStore,
    };

    return (
      <Provider {...stores}>
        <Flexbox
          className="version-switch-page"
          flexDirection="column"
        >

          <Flexbox
            className="version-switch-container"
            flexDirection="column"
          >

            {/* Logo */}
            <Flexbox
              className="version-switch-logo-container"
              flexDirection="column"
            >
              <a
                className="header__logo"
                href="https://www.peoplegoal.com/"
                aria-label="PeopleGoal"
                tabIndex="0"
              >
                <svg
                  width="152"
                  height="49"
                  viewBox="0 0 152 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="152" height="49" fill="" />

                  <mask
                    id="mask0_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="60"
                    y="1"
                    width="23"
                    height="27"
                  >
                    <path
                      d="M60.626 1.48633H71.726C78.275 1.48633 82.493 4.82832 82.493 10.5203V10.5943C82.493 16.6533 77.793 19.8503 71.358 19.8503H67.8V27.1963H60.62V1.48633H60.626ZM71.208 14.2673C73.764 14.2673 75.315 12.9473 75.315 10.9253V10.8513C75.315 8.65132 73.764 7.47232 71.171 7.47232H67.806V14.2723L71.208 14.2673Z"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask0_148_1899)">
                    <path
                      d="M59.1479 0.00830078H83.972V28.6733H59.1479V0.00830078Z"
                      fill="#03A5FB"
                    />
                  </g>

                  <mask
                    id="mask1_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="82"
                    y="6"
                    width="14"
                    height="22"
                  >
                    <path
                      d="M82.494 7.14826H89.494V11.1892C90.637 8.44425 92.478 6.66625 95.794 6.81425V14.2253H95.2C91.554 14.2253 89.489 16.3373 89.489 20.9703V27.1963H82.489V7.14826"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask1_148_1899)">
                    <path
                      d="M81.016 5.32715H97.273V28.6732H81.016V5.32715Z"
                      fill="#03A5FB"
                    />
                  </g>

                  <mask
                    id="mask2_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="95"
                    y="6"
                    width="23"
                    height="22"
                  >
                    <path
                      d="M95.793 17.3731V17.2991C95.793 11.5911 100.463 6.80908 106.912 6.80908C113.325 6.80908 117.956 11.5161 117.956 17.2241V17.2991C117.956 23.0071 113.286 27.7911 106.839 27.7911C100.427 27.7911 95.793 23.0831 95.793 17.3731ZM111.1 17.3731V17.2991C111.124 16.7207 111.031 16.1434 110.829 15.6011C110.627 15.0588 110.318 14.5625 109.921 14.1411C109.524 13.7198 109.047 13.3821 108.518 13.1477C107.988 12.9133 107.418 12.7869 106.839 12.7761C106.267 12.7763 105.701 12.8936 105.175 13.1206C104.65 13.3476 104.176 13.6795 103.784 14.0961C103.392 14.5126 103.089 15.005 102.893 15.5429C102.698 16.0808 102.615 16.6529 102.649 17.2241V17.2991C102.625 17.8775 102.718 18.4548 102.92 18.9971C103.123 19.5394 103.432 20.0358 103.829 20.4571C104.226 20.8784 104.703 21.2163 105.233 21.4507C105.762 21.6851 106.333 21.8113 106.912 21.8221C107.484 21.8215 108.05 21.7041 108.575 21.4769C109.101 21.2497 109.574 20.9177 109.966 20.5011C110.358 20.0844 110.661 19.592 110.856 19.0541C111.051 18.5162 111.134 17.9442 111.1 17.3731Z"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask2_148_1899)">
                    <path
                      d="M94.314 5.32715H119.435V29.2652H94.314V5.32715Z"
                      fill="#03A5FB"
                    />
                  </g>

                  <mask
                    id="mask3_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="117"
                    y="0"
                    width="14"
                    height="28"
                  >
                    <path
                      d="M119.409 12.8472H117.069V7.3472H119.409V6.9042C119.409 4.61821 119.932 2.9222 121.116 1.7402C122.343 0.524203 123.977 0.00720168 126.353 0.00720168C127.908 -0.0401531 129.461 0.146238 130.96 0.56018V5.5022C130.108 5.22762 129.217 5.09056 128.322 5.09619C127.022 5.09619 126.316 5.68818 126.316 6.97818V7.4592H130.916V12.8462H126.424V27.1952H119.404V12.8472"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask3_148_1899)">
                    <path
                      d="M115.591 -1.46875H132.438V28.6732H115.591V-1.46875Z"
                      fill="#03A5FB"
                    />
                  </g>

                  <mask
                    id="mask4_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="130"
                    y="6"
                    width="18"
                    height="22"
                  >
                    <path
                      d="M130.073 24.5571L132.711 20.3401C134.757 21.7318 137.154 22.5201 139.627 22.6151C140.853 22.6151 141.41 22.2471 141.41 21.5501V21.4731C141.41 20.7031 140.295 20.3731 138.177 19.7851C134.198 18.7581 131.038 17.4381 131.038 13.4391V13.3731C131.038 9.15713 134.46 6.81011 139.104 6.81011C142.027 6.80288 144.895 7.60258 147.393 9.12111L144.979 13.5211C143.163 12.4628 141.129 11.8351 139.032 11.6861C137.952 11.6861 137.394 12.0861 137.394 12.6411V12.7121C137.394 13.4821 138.546 13.8501 140.667 14.4751C144.643 15.5751 147.805 16.9331 147.805 20.7831V20.8561C147.805 25.2191 144.496 27.4951 139.588 27.4951C136.189 27.5277 132.863 26.5019 130.073 24.5601"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask4_148_1899)">
                    <path
                      d="M128.6 5.32715H149.283V28.9732H128.6V5.32715Z"
                      fill="#03A5FB"
                    />
                  </g>

                  <mask
                    id="mask5_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="3"
                    y="1"
                    width="22"
                    height="27"
                  >
                    <path
                      d="M3 1.48633H14.1C20.65 1.48633 24.869 4.82832 24.869 10.5203V10.5943C24.869 16.6533 20.169 19.8503 13.731 19.8503H10.179V27.1963H3V1.48633ZM13.582 14.2673C16.136 14.2673 17.69 12.9473 17.69 10.9253V10.8513C17.69 8.65132 16.136 7.47232 13.545 7.47232H10.179V14.2723L13.582 14.2673Z"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask5_148_1899)">
                    <path
                      d="M1.52295 0.00830078H26.3459V28.6733H1.52295V0.00830078Z"
                      fill="#170087"
                    />
                  </g>

                  <mask
                    id="mask6_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="24"
                    y="6"
                    width="15"
                    height="22"
                  >
                    <path
                      d="M24.869 7.14826H31.869V11.1892C33.011 8.44425 34.853 6.66625 38.169 6.81425V14.2253H37.581C33.935 14.2253 31.871 16.3373 31.871 20.9703V27.1963H24.871V7.14826"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask6_148_1899)">
                    <path
                      d="M23.392 5.32715H39.645V28.6732H23.392V5.32715Z"
                      fill="#170087"
                    />
                  </g>

                  <mask
                    id="mask7_148_1899"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="38"
                    y="6"
                    width="23"
                    height="22"
                  >
                    <path
                      d="M38.166 17.3731V17.2991C38.166 11.5911 42.836 6.80908 49.285 6.80908C55.698 6.80908 60.331 11.5161 60.331 17.2241V17.2991C60.331 23.0071 55.661 27.7911 49.212 27.7911C42.8 27.7911 38.166 23.0831 38.166 17.3731ZM53.475 17.3731V17.2991C53.4985 16.7206 53.4062 16.1433 53.2036 15.601C53.0009 15.0588 52.692 14.5624 52.295 14.1411C51.8979 13.7198 51.4206 13.382 50.8912 13.1476C50.3618 12.9132 49.7909 12.7869 49.212 12.7761C48.6399 12.7765 48.0739 12.8938 47.5487 13.1208C47.0236 13.3477 46.5503 13.6796 46.158 14.0961C45.7657 14.5126 45.4627 15.005 45.2675 15.5429C45.0723 16.0808 44.9891 16.6529 45.023 17.2241V17.2991C44.9995 17.8775 45.0918 18.4548 45.2944 18.9971C45.497 19.5394 45.8059 20.0358 46.203 20.4571C46.6 20.8783 47.0771 21.2161 47.6063 21.4505C48.1356 21.6849 48.7063 21.8112 49.285 21.8221C49.8573 21.8218 50.4235 21.7046 50.9488 21.4776C51.4742 21.2506 51.9476 20.9186 52.34 20.5021C52.7324 20.0854 53.0355 19.5929 53.2307 19.0548C53.4259 18.5167 53.509 17.9444 53.475 17.3731Z"
                      fill="white"
                    />
                  </mask>

                  <g mask="url(#mask7_148_1899)">
                    <path
                      d="M36.688 5.32715H61.807V29.2652H36.688V5.32715Z"
                      fill="#170087"
                    />
                  </g>

                  <path
                    d="M66.146 39.6919H63.0664V37.7495H66.146C66.6219 37.7495 67.0093 37.672 67.3081 37.5171C67.6069 37.3566 67.8255 37.1353 67.9639 36.853C68.1022 36.5708 68.1714 36.2526 68.1714 35.8984C68.1714 35.5387 68.1022 35.2039 67.9639 34.894C67.8255 34.5841 67.6069 34.3351 67.3081 34.147C67.0093 33.9588 66.6219 33.8647 66.146 33.8647H63.9297V44H61.4395V31.9141H66.146C67.0923 31.9141 67.903 32.0856 68.5781 32.4287C69.2588 32.7663 69.779 33.2339 70.1387 33.8315C70.4984 34.4292 70.6782 35.1126 70.6782 35.8818C70.6782 36.6621 70.4984 37.3372 70.1387 37.9072C69.779 38.4772 69.2588 38.9172 68.5781 39.2271C67.903 39.5369 67.0923 39.6919 66.146 39.6919ZM76.2646 44.166C75.5674 44.166 74.9421 44.0553 74.3887 43.834C73.8353 43.6071 73.3649 43.2944 72.9775 42.896C72.5957 42.4976 72.3024 42.0355 72.0977 41.5098C71.8929 40.9785 71.7905 40.4141 71.7905 39.8164V39.4844C71.7905 38.8037 71.8874 38.1812 72.0811 37.6167C72.2747 37.0522 72.5514 36.5625 72.9111 36.1475C73.2764 35.7324 73.7191 35.4142 74.2393 35.1929C74.7594 34.966 75.346 34.8525 75.999 34.8525C76.6354 34.8525 77.1999 34.9577 77.6924 35.168C78.1849 35.3783 78.5972 35.6771 78.9292 36.0645C79.2668 36.4518 79.5213 36.9167 79.6929 37.459C79.8644 37.9958 79.9502 38.5934 79.9502 39.252V40.248H72.8115V38.6543H77.6011V38.4717C77.6011 38.1396 77.5402 37.8436 77.4185 37.5835C77.3022 37.3179 77.1252 37.1076 76.8872 36.9526C76.6493 36.7977 76.3449 36.7202 75.9741 36.7202C75.6587 36.7202 75.3875 36.7894 75.1606 36.9277C74.9338 37.0661 74.7484 37.2598 74.6045 37.5088C74.4661 37.7578 74.361 38.0511 74.2891 38.3887C74.2227 38.7207 74.1895 39.0859 74.1895 39.4844V39.8164C74.1895 40.1761 74.2395 40.5081 74.3389 40.8125C74.444 41.1169 74.5907 41.3797 74.7788 41.6011C74.9725 41.8224 75.2049 41.994 75.4761 42.1157C75.7528 42.2375 76.0654 42.2983 76.4141 42.2983C76.8457 42.2983 77.2469 42.2153 77.6177 42.0493C77.994 41.8778 78.3177 41.6204 78.5889 41.2773L79.751 42.5391C79.5628 42.8102 79.3055 43.0703 78.979 43.3193C78.658 43.5684 78.2707 43.7731 77.8169 43.9336C77.3631 44.0885 76.8457 44.166 76.2646 44.166ZM80.9297 39.6006V39.4263C80.9297 38.7677 81.0238 38.1618 81.2119 37.6084C81.4001 37.0495 81.674 36.5653 82.0337 36.1558C82.3934 35.7463 82.8361 35.4281 83.3618 35.2012C83.8875 34.9688 84.4907 34.8525 85.1714 34.8525C85.8521 34.8525 86.458 34.9688 86.9893 35.2012C87.5205 35.4281 87.966 35.7463 88.3257 36.1558C88.6909 36.5653 88.9676 37.0495 89.1558 37.6084C89.3439 38.1618 89.438 38.7677 89.438 39.4263V39.6006C89.438 40.2536 89.3439 40.8595 89.1558 41.4185C88.9676 41.9718 88.6909 42.4561 88.3257 42.8711C87.966 43.2806 87.5233 43.5988 86.9976 43.8257C86.4718 44.0526 85.8687 44.166 85.188 44.166C84.5073 44.166 83.9014 44.0526 83.3701 43.8257C82.8444 43.5988 82.3989 43.2806 82.0337 42.8711C81.674 42.4561 81.4001 41.9718 81.2119 41.4185C81.0238 40.8595 80.9297 40.2536 80.9297 39.6006ZM83.3203 39.4263V39.6006C83.3203 39.9769 83.3535 40.3283 83.4199 40.6548C83.4863 40.9813 83.5915 41.269 83.7354 41.5181C83.8848 41.7616 84.0785 41.9525 84.3164 42.0908C84.5544 42.2292 84.8449 42.2983 85.188 42.2983C85.52 42.2983 85.805 42.2292 86.043 42.0908C86.2809 41.9525 86.4718 41.7616 86.6157 41.5181C86.7596 41.269 86.8647 40.9813 86.9312 40.6548C87.0031 40.3283 87.0391 39.9769 87.0391 39.6006V39.4263C87.0391 39.061 87.0031 38.7179 86.9312 38.397C86.8647 38.0705 86.7568 37.7827 86.6074 37.5337C86.4635 37.2791 86.2726 37.0799 86.0347 36.936C85.7967 36.7922 85.509 36.7202 85.1714 36.7202C84.8338 36.7202 84.5461 36.7922 84.3081 36.936C84.0757 37.0799 83.8848 37.2791 83.7354 37.5337C83.5915 37.7827 83.4863 38.0705 83.4199 38.397C83.3535 38.7179 83.3203 39.061 83.3203 39.4263ZM93.2979 36.7451V47.4531H90.9072V35.0186H93.1235L93.2979 36.7451ZM98.9839 39.4097V39.584C98.9839 40.237 98.9064 40.8429 98.7515 41.4019C98.6021 41.9608 98.3807 42.4478 98.0874 42.8628C97.7941 43.2723 97.4289 43.5933 96.9917 43.8257C96.5601 44.0526 96.062 44.166 95.4976 44.166C94.9497 44.166 94.4738 44.0553 94.0698 43.834C93.6659 43.6126 93.3255 43.3027 93.0488 42.9043C92.7777 42.5003 92.5591 42.0327 92.3931 41.5015C92.2271 40.9702 92.0998 40.4002 92.0112 39.7915V39.335C92.0998 38.682 92.2271 38.0843 92.3931 37.542C92.5591 36.9941 92.7777 36.521 93.0488 36.1226C93.3255 35.7186 93.6631 35.4059 94.0615 35.1846C94.4655 34.9632 94.9386 34.8525 95.481 34.8525C96.0509 34.8525 96.5518 34.9604 96.9834 35.1763C97.4206 35.3921 97.7858 35.702 98.0791 36.106C98.3779 36.5099 98.6021 36.9914 98.7515 37.5503C98.9064 38.1092 98.9839 38.729 98.9839 39.4097ZM96.585 39.584V39.4097C96.585 39.0278 96.5518 38.6764 96.4854 38.3555C96.4245 38.029 96.3249 37.744 96.1865 37.5005C96.0537 37.257 95.8766 37.0688 95.6553 36.936C95.4395 36.7977 95.1766 36.7285 94.8667 36.7285C94.5402 36.7285 94.2607 36.7811 94.0283 36.8862C93.8014 36.9914 93.616 37.1436 93.4722 37.3428C93.3283 37.542 93.2204 37.7799 93.1484 38.0566C93.0765 38.3333 93.0322 38.646 93.0156 38.9946V40.1484C93.0433 40.5579 93.1208 40.9259 93.248 41.2524C93.3753 41.5734 93.5718 41.828 93.8374 42.0161C94.103 42.2043 94.4517 42.2983 94.8833 42.2983C95.1987 42.2983 95.4644 42.2292 95.6802 42.0908C95.896 41.9469 96.0703 41.7505 96.2031 41.5015C96.3415 41.2524 96.4383 40.9647 96.4937 40.6382C96.5545 40.3117 96.585 39.9603 96.585 39.584ZM102.993 31.25V44H100.594V31.25H102.993ZM109.103 44.166C108.405 44.166 107.78 44.0553 107.227 43.834C106.673 43.6071 106.203 43.2944 105.815 42.896C105.434 42.4976 105.14 42.0355 104.936 41.5098C104.731 40.9785 104.628 40.4141 104.628 39.8164V39.4844C104.628 38.8037 104.725 38.1812 104.919 37.6167C105.113 37.0522 105.389 36.5625 105.749 36.1475C106.114 35.7324 106.557 35.4142 107.077 35.1929C107.597 34.966 108.184 34.8525 108.837 34.8525C109.473 34.8525 110.038 34.9577 110.53 35.168C111.023 35.3783 111.435 35.6771 111.767 36.0645C112.105 36.4518 112.359 36.9167 112.531 37.459C112.702 37.9958 112.788 38.5934 112.788 39.252V40.248H105.649V38.6543H110.439V38.4717C110.439 38.1396 110.378 37.8436 110.256 37.5835C110.14 37.3179 109.963 37.1076 109.725 36.9526C109.487 36.7977 109.183 36.7202 108.812 36.7202C108.497 36.7202 108.225 36.7894 107.999 36.9277C107.772 37.0661 107.586 37.2598 107.442 37.5088C107.304 37.7578 107.199 38.0511 107.127 38.3887C107.061 38.7207 107.027 39.0859 107.027 39.4844V39.8164C107.027 40.1761 107.077 40.5081 107.177 40.8125C107.282 41.1169 107.429 41.3797 107.617 41.6011C107.81 41.8224 108.043 41.994 108.314 42.1157C108.591 42.2375 108.903 42.2983 109.252 42.2983C109.684 42.2983 110.085 42.2153 110.456 42.0493C110.832 41.8778 111.156 41.6204 111.427 41.2773L112.589 42.5391C112.401 42.8102 112.143 43.0703 111.817 43.3193C111.496 43.5684 111.109 43.7731 110.655 43.9336C110.201 44.0885 109.684 44.166 109.103 44.166ZM123.878 37.6831V42.4727C123.69 42.6995 123.399 42.9458 123.006 43.2114C122.613 43.4715 122.107 43.6956 121.487 43.8838C120.868 44.0719 120.118 44.166 119.238 44.166C118.458 44.166 117.746 44.0387 117.104 43.7842C116.463 43.5241 115.909 43.145 115.444 42.647C114.985 42.1489 114.631 41.5402 114.382 40.8208C114.133 40.0959 114.008 39.2686 114.008 38.3389V37.5835C114.008 36.6538 114.127 35.8265 114.365 35.1016C114.609 34.3766 114.955 33.7651 115.403 33.2671C115.851 32.769 116.385 32.39 117.005 32.1299C117.625 31.8698 118.314 31.7397 119.072 31.7397C120.123 31.7397 120.986 31.9113 121.662 32.2544C122.337 32.592 122.851 33.0623 123.206 33.6655C123.565 34.2632 123.787 34.9494 123.87 35.7241H121.454C121.393 35.3146 121.277 34.9577 121.105 34.6533C120.934 34.349 120.688 34.111 120.367 33.9395C120.051 33.7679 119.642 33.6821 119.138 33.6821C118.723 33.6821 118.352 33.7679 118.026 33.9395C117.705 34.1055 117.434 34.3517 117.212 34.6782C116.991 35.0047 116.822 35.4087 116.706 35.8901C116.59 36.3716 116.532 36.9305 116.532 37.5669V38.3389C116.532 38.9697 116.593 39.5286 116.714 40.0156C116.836 40.4971 117.016 40.9038 117.254 41.2358C117.497 41.5623 117.796 41.8086 118.15 41.9746C118.505 42.1406 118.917 42.2236 119.387 42.2236C119.78 42.2236 120.107 42.1904 120.367 42.124C120.632 42.0576 120.845 41.9774 121.006 41.8833C121.172 41.7837 121.299 41.6896 121.388 41.6011V39.4595H119.113V37.6831H123.878ZM125.355 39.6006V39.4263C125.355 38.7677 125.45 38.1618 125.638 37.6084C125.826 37.0495 126.1 36.5653 126.459 36.1558C126.819 35.7463 127.262 35.4281 127.788 35.2012C128.313 34.9688 128.917 34.8525 129.597 34.8525C130.278 34.8525 130.884 34.9688 131.415 35.2012C131.946 35.4281 132.392 35.7463 132.751 36.1558C133.117 36.5653 133.393 37.0495 133.582 37.6084C133.77 38.1618 133.864 38.7677 133.864 39.4263V39.6006C133.864 40.2536 133.77 40.8595 133.582 41.4185C133.393 41.9718 133.117 42.4561 132.751 42.8711C132.392 43.2806 131.949 43.5988 131.423 43.8257C130.898 44.0526 130.294 44.166 129.614 44.166C128.933 44.166 128.327 44.0526 127.796 43.8257C127.27 43.5988 126.825 43.2806 126.459 42.8711C126.1 42.4561 125.826 41.9718 125.638 41.4185C125.45 40.8595 125.355 40.2536 125.355 39.6006ZM127.746 39.4263V39.6006C127.746 39.9769 127.779 40.3283 127.846 40.6548C127.912 40.9813 128.017 41.269 128.161 41.5181C128.311 41.7616 128.504 41.9525 128.742 42.0908C128.98 42.2292 129.271 42.2983 129.614 42.2983C129.946 42.2983 130.231 42.2292 130.469 42.0908C130.707 41.9525 130.898 41.7616 131.042 41.5181C131.185 41.269 131.291 40.9813 131.357 40.6548C131.429 40.3283 131.465 39.9769 131.465 39.6006V39.4263C131.465 39.061 131.429 38.7179 131.357 38.397C131.291 38.0705 131.183 37.7827 131.033 37.5337C130.889 37.2791 130.698 37.0799 130.46 36.936C130.222 36.7922 129.935 36.7202 129.597 36.7202C129.26 36.7202 128.972 36.7922 128.734 36.936C128.501 37.0799 128.311 37.2791 128.161 37.5337C128.017 37.7827 127.912 38.0705 127.846 38.397C127.779 38.7179 127.746 39.061 127.746 39.4263ZM140.181 41.9746V37.9736C140.181 37.6859 140.134 37.4396 140.04 37.2349C139.945 37.0246 139.799 36.8613 139.6 36.7451C139.406 36.6289 139.154 36.5708 138.844 36.5708C138.579 36.5708 138.349 36.6178 138.155 36.7119C137.962 36.8005 137.812 36.9305 137.707 37.1021C137.602 37.2681 137.549 37.4645 137.549 37.6914H135.159C135.159 37.3096 135.247 36.9471 135.424 36.604C135.601 36.2609 135.859 35.9593 136.196 35.6992C136.534 35.4336 136.935 35.2261 137.4 35.0767C137.87 34.9272 138.396 34.8525 138.977 34.8525C139.674 34.8525 140.294 34.9688 140.836 35.2012C141.379 35.4336 141.805 35.7822 142.115 36.2471C142.43 36.7119 142.588 37.293 142.588 37.9902V41.8335C142.588 42.326 142.618 42.73 142.679 43.0454C142.74 43.3553 142.829 43.6265 142.945 43.8589V44H140.529C140.413 43.7565 140.325 43.4521 140.264 43.0869C140.208 42.7161 140.181 42.3454 140.181 41.9746ZM140.496 38.5298L140.513 39.8828H139.176C138.861 39.8828 138.587 39.9188 138.354 39.9907C138.122 40.0627 137.931 40.165 137.782 40.2979C137.632 40.4251 137.522 40.5745 137.45 40.7461C137.383 40.9176 137.35 41.1058 137.35 41.3105C137.35 41.5153 137.397 41.7007 137.491 41.8667C137.585 42.0272 137.721 42.1545 137.898 42.2485C138.075 42.3371 138.283 42.3813 138.521 42.3813C138.88 42.3813 139.193 42.3094 139.458 42.1655C139.724 42.0216 139.929 41.8446 140.073 41.6343C140.222 41.424 140.3 41.2248 140.305 41.0366L140.936 42.0493C140.847 42.2762 140.726 42.5114 140.571 42.7549C140.421 42.9984 140.23 43.228 139.998 43.4438C139.766 43.6541 139.486 43.8285 139.16 43.9668C138.833 44.0996 138.446 44.166 137.998 44.166C137.428 44.166 136.91 44.0526 136.445 43.8257C135.986 43.5933 135.621 43.2751 135.35 42.8711C135.084 42.4616 134.951 41.9967 134.951 41.4766C134.951 41.0062 135.04 40.5884 135.217 40.2231C135.394 39.8579 135.654 39.5508 135.997 39.3018C136.346 39.0472 136.78 38.8563 137.3 38.729C137.82 38.5962 138.424 38.5298 139.11 38.5298H140.496ZM146.954 31.25V44H144.555V31.25H146.954Z"
                    fill="#170087"
                  />
                </svg>
              </a>
              {/* {Cookies.get('theme') === 'dark' ? (
                <img
                  alt="logo"
                  src={I18n.t('js.pg_logo_white')}
                  className="auth-view-logo"
                />
              ) : (                      
                <a class="header__logo" href="https://www.peoplegoal.com/" aria-label="Peoplegoal" tabindex="0">      
                 <img src="dcef7142-4d77-498c-a316-642efebb911e" alt="PeopleGoal" />
            </a>
              )} */}
            </Flexbox>

            {/* Heading */}
            <h1 className="version-switch-title">
              Which version would you like to continue with?
            </h1>

            {/* Version Cards */}
            <Flexbox
              className="version-cards"
              flexDirection="row"
            >

              {/* Version 1 */}
              <Card
                interactive={true}
                onClick={() =>
                  Utilities.navigate('/version-switch/v1')
                }
                className="version-card"
              >
                <Flexbox
                  className="version-card-content"
                  flexDirection="column"
                >

                  <div className="version-card-title">
                    {I18n.t('js.version_1')}
                  </div>

                  <div className="version-card-bottom">

                    <div className="version-arrow">
                      <Icon
                        icon="arrow-right"
                        size={20}
                      />
                    </div>

                    <div className="version-number">
                      1
                    </div>

                  </div>

                </Flexbox>
              </Card>


              {/* Version 2 */}
              <Card
                interactive={true}
                onClick={() =>
                  Utilities.navigate('/dashboard')
                }
                className="version-card"
              >
                <Flexbox
                  className="version-card-content"
                  flexDirection="column"
                >

                  <div className="version-card-title">
                    {I18n.t('js.version_2')}
                  </div>

                  <div className="version-card-bottom">

                    <div className="version-arrow">
                      <Icon
                        icon="arrow-right"
                        size={20}
                      />
                    </div>

                    <div className="version-number">
                      2
                    </div>

                  </div>

                </Flexbox>
              </Card>

            </Flexbox>

          </Flexbox>

          {/* Footer */}
          <Flexbox className="version-switch-footer">

            <div className="version-footer-copyright">
              Copyright PeopleGoal.com. All rights reserved.
            </div>


          </Flexbox>

        </Flexbox>
      </Provider>
    );
  }
}